import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import { architeckCall } from 'database';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Container } from "reactstrap";
import { toggleAlert } from 'store/functions/system';
import { getUrlParameter } from 'utils/urls';
import DeveloperLogCreate from './ComponentsView/DeveloperLogCreate';
import DeveloperLogView from './ComponentsView/DeveloperLogView';
import NavSelector from './ComponentsView/NavSelector';


class ProjectsView extends React.Component {

    state = {
        navPill: 1,
        project: {},
        project_logs_developers: [],
    }

    setNavPill = () => {

        const navPill = getUrlParameter('nav')

        if(navPill) {
            this.setState({navPill: parseInt(navPill)})
        }

    }

    toggleNavs = (e,  index) => {
        e.preventDefault();
        this.setState({ navPill: index });
    };

    componentWillMount = () => {

        const found_project = this.setProject()
        this.setProjectClientDevelopers(found_project);
        this.setNavPill();

    }

    setProject = () => {

        const _id = this.props.match.params._id;
        const found_project = this.props.app_projects.find(a => a._id === _id);

        if(found_project) {
            this.setState({project: found_project});
            return found_project
        } else {
            this.setState({shouldRedirect: '/developers'})
        }

    }

    setProjectClientDevelopers = async (found_project) => {

        if(found_project) {

            let project_logs_developers = await architeckCall({
                method: 'get',
                url: `/api/v1/project_logs_developers/list?find_by=project__${found_project._id}&loop=true&limit=500`
            })

            if(project_logs_developers.success) {

                project_logs_developers = project_logs_developers.data.filter(l => l.user._id === this.props.viewing_user._id)
                this.setState({project_logs_developers})

            } else {

                toggleAlert(true, 'danger', 'An error occurred fetching project log data.', 'infinite' )

            }

        }

    }

    onAddDeveloperLog = (log) => {

        let project_logs_developers = [...this.state.project_logs_developers];
        project_logs_developers.unshift(log)

        this.setState({project_logs_developers})

    }

     //when a log is added add it to the state
    onUpdateDeveloperLog = (object) => {

        let project_logs_developers = [...this.state.project_logs_developers]
    
        project_logs_developers[project_logs_developers.findIndex(el => el._id === object._id)] = object;
        this.setState({project_logs_developers})

    }

    onRemoveDeveloperLog = (log) => {

        let project_logs_developers = [...this.state.project_logs_developers];
        project_logs_developers = project_logs_developers.filter(f => f._id !== log);

        this.setState({project_logs_developers})

    }
    
    render() {

        if(this.state.shouldRedirect) {
            return <Redirect to={this.state.shouldRedirect} />
        }

        const project_logs_developers = this.state.project_logs_developers;
        const project = this.state.project;

        return (
            <>

            <Container>

                <Helmet>
                    <title>Dashboard</title>
                    <meta name="description" content="Dashboard" />
                </Helmet>

                {this.state.ModalCreate}

                <DashHeaderOpen 
                    icon="fas fa-long-arrow-alt-left" 
                    icon_link="/developers" 
                    title={<span>{this.state.project.name}</span>} breadcrumb_1={<span>Company: {this.state.project.company.name}</span>}
                />

                <NavSelector navPill={this.state.navPill} toggleNavs={(e, index) => this.toggleNavs(e, index)} />

                {this.state.navPill === 1 ? 
                    <DeveloperLogCreate
                        onAddDeveloperLog={(log) => this.onAddDeveloperLog(log)}
                        project={project}
                    />
                : null}
                {this.state.navPill === 2 ? 
                    <DeveloperLogView
                        onUpdateDeveloperLog={(log) => this.onUpdateDeveloperLog(log)}
                        project_logs_developers={project_logs_developers}
                        onRemoveDeveloperLog={(log) => this.onRemoveDeveloperLog(log)}
                        project={project}
                    />
                : null}

            </Container>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        viewing_user: state.auth.viewing_user,
        app_projects: state.projects.app_projects,  
    };
};

export default connect(mapStateToProps, '')(ProjectsView);

